// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}

.loader {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-weight: 900;
  font-size: 24px;
  line-height: 90px;
}
.loader__title {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-45%, 0%);
}
.loader .linear_progress {
  position: absolute;
  top: 58%;
  left: 50%;
  transform: translate(-50%, 0%);
  background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);
  margin-left: 1em;
  width: 414px;
}
.loader .linear_progress .MuiLinearProgress-bar {
  background-color: #fff;
  width: 1.5em;
}

.HLinks:hover {
  background: #F8F8F8;
}

.BOXXX {
  background: white;
  font-size: 16px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 162px;
  margin-right: 58px;
}

.selected {
  border-radius: 18px;
}

.credential {
  flex-grow: 1;
}
.credential__body {
  background-color: hsla(0, 0%, 98%, 0.83);
  position: relative;
}
.credential__body .links_container .sc-ftvSup {
  padding: 0 72px 0 75px;
}
.credential__body .setting__container {
  padding-right: 72px;
  padding-left: 75px;
}
.credential__body .setting_btn {
  position: relative;
}
.credential__body .setting_btn.SBOX:before {
  background-color: #4D4DF6;
  bottom: -12px;
  content: "";
  height: 2px;
  left: 0px;
  position: absolute;
  right: 0px;
  transform-origin: left center;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  width: 100%;
}
.credential__body .setting_btn p {
  margin-bottom: 0;
  font-size: 16px;
}
.credential__body .setting_btn p a {
  color: hsl(233, 100%, 57%);
  text-decoration: none;
}
.credential__body .refresh__msg .header__msg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}
.credential__body .refresh__msg .header__msg .success_icon_msg {
  font-weight: 700;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
}
.credential__body .refresh__msg .header__msg .success-close {
  font-weight: 400;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
}
.credential__body .refresh__msg .success-msg {
  margin: 0;
  font-weight: 300;
  font-size: 12px;
  color: #FDFDFD;
  letter-spacing: 0.15px;
  margin-bottom: 13px;
  overflow: hidden;
}
.credential__body__success .success-msg {
  color: hsl(217, 24%, 17%);
  margin-left: 1em;
  margin-right: 1em;
}
.credential__body__success .success-close {
  color: hsl(214, 4%, 39%);
  text-decoration: underline;
  cursor: pointer;
}
.credential__body__list .tab__header .tab__header__item.active {
  background: hsl(214, 4%, 31%);
  color: #fff;
}
.credential__body__list .tab__header .tab__header__item {
  width: 186px;
  transition: all 0.1s ease-in-out;
}
.credential__body__list .tab__body .MuiBox-root {
  padding: 0;
}
.credential__body__list .tab__body .MuiBox-root pre {
  margin-top: 0 !important;
  background-color: hsl(214, 4%, 31%) !important;
  overflow-y: auto;
  border-radius: 0 !important;
  scrollbar-width: thin;
  scrollbar-color: #C4C4C4 hsl(223, 4%, 66%);
}
.credential__body__list .tab__body .MuiBox-root pre::-webkit-scrollbar {
  width: 0.25em;
  height: 0.25em;
  margin-right: -1em;
  background-color: hsl(223, 4%, 66%);
}
.credential__body__list .tab__body .MuiBox-root pre::-webkit-scrollbar-thumb {
  background-color: #C4C4C4;
  border-radius: 3px;
}
.credential__body__list .tab__body .MuiBox-root pre::-webkit-scrollbar-thumb:hover {
  background-color: hsla(240, 100%, 44%, 0.39);
}
.credential__body__header {
  margin-bottom: 0.75em;
}
.credential__body__header-text {
  font-size: 30px;
  letter-spacing: 0.15px;
  font-weight: 900;
  color: hsl(237, 69%, 40%);
}
.credential__body__header-text span {
  opacity: 0.5;
}
.credential__body__header-btn {
  background-color: #1F27AC;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 5px rgba(0, 0, 0, 0.2);
  border: none;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.25px;
  padding-left: 2rem;
  padding-right: 2rem;
}
.credential .setting__bottom__container {
  padding: 0px 33px 13px;
  background-color: hsl(0, 0%, 100%);
  border-radius: 5px;
}
.credential .setting__bottom__container .subHeader, .credential .setting__bottom__container .dark {
  font-weight: 400;
  font-size: 15px;
  color: hsl(214, 4%, 31%);
}
.credential .setting__bottom__container .subPara {
  color: hsl(223, 4%, 66%);
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 18px;
}
.credential .setting__bottom__container .MuiGrid-root .MuiInput-root input {
  color: #A4A6AB;
  padding-top: 0;
  padding-bottom: 0;
  line-height: 2;
  font-size: 12px;
}
.credential .setting__bottom__container .user__details {
  border: 1px solid #E9E9E9;
  padding: 0px 25px 0px 11px;
  border-radius: 5px;
  margin-bottom: 32px;
  height: 60px;
}
.credential .setting__bottom__container .user__details span {
  font-weight: 700;
  font-size: 12px;
  color: #606367;
  letter-spacing: 0.15px;
}
.credential .setting__bottom__container .user__details .MuiBox-root {
  margin-left: 8px;
}

.create__gate {
  text-align: center;
}
.create__gate__body {
  padding: 1px 14px 3px;
}
.create__gate__body .input {
  background-color: #fff;
  border: none;
  width: 100% !important;
  padding: 13px 18px;
  border-radius: 5px;
}
.create__gate__body .input input {
  padding-bottom: 0;
}
.create__gate__body .input input::placeholder {
  color: #212936;
  opacity: 1;
}
.create__gate__body .input:focus-within {
  box-shadow: 0 0 0.05rem 0.05rem hsl(237, 46%, 75%);
}
.create__gate__body__label {
  margin: 0.5em;
  font-size: 10px;
}
.create__gate__body__footer {
  display: flex;
  justify-content: center;
}
.create__gate__body__footer .close__btn {
  background: #FFFFFF;
  border: 1px solid #D5D9FE !important;
  border-radius: 5px;
  padding: 2px 34px !important;
  text-transform: capitalize;
  color: hsl(233, 100%, 57%);
  letter-spacing: 0.25px !important;
  margin-right: 15px;
}
.create__gate__body .error {
  box-shadow: 0 0 0.05rem 0.05rem hsl(5, 100%, 69%);
}
.create__gate.dashboard {
  padding: 9px 14px;
}

.update__error, .updateBlank__error {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/credentialList/index.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;ACvDF;;AD6DE;EACI,yBAAA;AC1DN;;ADyDE;EACI,yBAAA;ACtDN;;ADqDE;EACI,yBAAA;AClDN;;ADiDE;EACI,yBAAA;AC9CN;;AD6CE;EACI,yBAAA;AC1CN;;ADyCE;EACI,yBAAA;ACtCN;;ADqCE;EACI,yBAAA;AClCN;;ADiCE;EACI,yBAAA;AC9BN;;AD6BE;EACI,yBAAA;AC1BN;;ADyBE;EACI,0BAAA;ACtBN;;ADqBE;EACI,0BAAA;AClBN;;ADiBE;EACI,0BAAA;ACdN;;ADaE;EACI,0BAAA;ACVN;;ADSE;EACI,0BAAA;ACNN;;ADKE;EACI,0BAAA;ACFN;;ADCE;EACI,0BAAA;ACEN;;ADHE;EACI,0BAAA;ACMN;;ADPE;EACI,0BAAA;ACUN;;ADXE;EACI,0BAAA;ACcN;;ADfE;EACI,0BAAA;ACkBN;;ADnBE;EACI,0BAAA;ACsBN;;ADvBE;EACI,0BAAA;AC0BN;;AD3BE;EACI,0BAAA;AC8BN;;AD/BE;EACI,0BAAA;ACkCN;;ADnCE;EACI,0BAAA;ACsCN;;ADvCE;EACI,0BAAA;AC0CN;;AD3CE;EACI,0BAAA;AC8CN;;AD/CE;EACI,0BAAA;ACkDN;;ADnDE;EACI,0BAAA;ACsDN;;ADvDE;EACI,0BAAA;AC0DN;;AD3DE;EACI,0BAAA;AC8DN;;AD/DE;EACI,0BAAA;ACkEN;;ADnEE;EACI,0BAAA;ACsEN;;ADvEE;EACI,0BAAA;AC0EN;;AD3EE;EACI,0BAAA;AC8EN;;AD/EE;EACI,0BAAA;ACkFN;;ADnFE;EACI,0BAAA;ACsFN;;ADvFE;EACI,0BAAA;AC0FN;;AD3FE;EACI,0BAAA;AC8FN;;AD/FE;EACI,0BAAA;ACkGN;;ADnGE;EACI,0BAAA;ACsGN;;ADvGE;EACI,0BAAA;AC0GN;;AD3GE;EACI,0BAAA;AC8GN;;AD/GE;EACI,0BAAA;ACkHN;;ADnHE;EACI,0BAAA;ACsHN;;ADvHE;EACI,0BAAA;AC0HN;;AD3HE;EACI,0BAAA;AC8HN;;AD/HE;EACI,0BAAA;ACkIN;;ADnIE;EACI,0BAAA;ACsIN;;ADvIE;EACI,0BAAA;AC0IN;;AD3IE;EACI,0BAAA;AC8IN;;AD/IE;EACI,0BAAA;ACkJN;;ADnJE;EACI,0BAAA;ACsJN;;ADvJE;EACI,0BAAA;AC0JN;;AD3JE;EACI,0BAAA;AC8JN;;AD/JE;EACI,0BAAA;ACkKN;;ADnKE;EACI,0BAAA;ACsKN;;ADvKE;EACI,0BAAA;AC0KN;;AD3KE;EACI,0BAAA;AC8KN;;AD/KE;EACI,0BAAA;ACkLN;;ADnLE;EACI,0BAAA;ACsLN;;ADvLE;EACI,0BAAA;AC0LN;;AD3LE;EACI,0BAAA;AC8LN;;AD/LE;EACI,0BAAA;ACkMN;;ADnME;EACI,0BAAA;ACsMN;;ADvME;EACI,0BAAA;AC0MN;;AD3ME;EACI,0BAAA;AC8MN;;AD/ME;EACI,0BAAA;ACkNN;;ADnNE;EACI,0BAAA;ACsNN;;ADvNE;EACI,0BAAA;AC0NN;;AD3NE;EACI,0BAAA;AC8NN;;AD/NE;EACI,0BAAA;ACkON;;ADnOE;EACI,0BAAA;ACsON;;ADvOE;EACI,0BAAA;AC0ON;;AD3OE;EACI,0BAAA;AC8ON;;AD/OE;EACI,0BAAA;ACkPN;;ADnPE;EACI,0BAAA;ACsPN;;ADvPE;EACI,0BAAA;AC0PN;;AD3PE;EACI,0BAAA;AC8PN;;AD/PE;EACI,0BAAA;ACkQN;;ADnQE;EACI,0BAAA;ACsQN;;ADvQE;EACI,0BAAA;AC0QN;;AD3QE;EACI,0BAAA;AC8QN;;AD/QE;EACI,0BAAA;ACkRN;;ADnRE;EACI,0BAAA;ACsRN;;ADvRE;EACI,0BAAA;AC0RN;;AD3RE;EACI,0BAAA;AC8RN;;AD/RE;EACI,0BAAA;ACkSN;;ADnSE;EACI,0BAAA;ACsSN;;ADvSE;EACI,0BAAA;AC0SN;;AD3SE;EACI,0BAAA;AC8SN;;AD/SE;EACI,0BAAA;ACkTN;;ADnTE;EACI,0BAAA;ACsTN;;ADvTE;EACI,0BAAA;AC0TN;;AD3TE;EACI,0BAAA;AC8TN;;AD/TE;EACI,0BAAA;ACkUN;;ADnUE;EACI,0BAAA;ACsUN;;ADvUE;EACI,0BAAA;AC0UN;;AD3UE;EACI,0BAAA;AC8UN;;AD/UE;EACI,2BAAA;ACkVN;;AD9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;ACiVF;;AD9UA;EACE,yBA9Ca;AC+Xf;AD/UE;EAEE,yBAnDW;ACmYf;AD7UE;EACE,qBAAA;AC+UJ;;AD3UA;EACE,eAAA;AC8UF;;AAzaA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA4aJ;AA1aI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;AA4aR;AAzaI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,2GAAA;EACA,gBAAA;EACA,YAAA;AA2aR;AAvaQ;EACI,sBAAA;EACA,YAAA;AAyaZ;;AApaA;EACI,mBAAA;AAuaJ;;AApaA;EAEI,iBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,kBAAA;AAqaJ;;AAjaA;EACI,mBAAA;AAoaJ;;AAjaA;EACI,YAAA;AAoaJ;AAlaI;EACI,wCDlDQ;ECoDR,kBAAA;AAmaR;AAhaY;EACI,sBAAA;AAkahB;AA9ZQ;EACI,mBAAA;EACA,kBAAA;AAgaZ;AA7ZQ;EACI,kBAAA;AA+ZZ;AA7ZgB;EACI,yBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EAEA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,6DAAA;EAEA,WAAA;AA6ZpB;AA1ZY;EACI,gBAAA;EACA,eAAA;AA4ZhB;AA3ZgB;EACI,0BD/FF;ECgGE,qBAAA;AA6ZpB;AAvZY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAyZhB;AAxZgB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA0ZpB;AAxZgB;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA0ZpB;AAvZY;EACI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAyZhB;AAnZY;EACI,yBDrHD;ECsHC,gBAAA;EACA,iBAAA;AAqZhB;AAlZY;EACI,wBDxHD;ECyHC,0BAAA;EACA,eAAA;AAoZhB;AA9YgB;EACI,6BDvHL;ECwHK,WAAA;AAgZpB;AA9YgB;EACG,YAAA;EACA,gCAAA;AAgZnB;AA5YgB;EACI,UAAA;AA8YpB;AA7YoB;EACI,wBAAA;EACA,8CAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,0CAAA;AA+YxB;AA7YwB;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mCD5IX;AC2hBf;AA5YwB;EACE,yBAAA;EACA,kBAAA;AA8Y1B;AA5Y0B;EACE,4CAAA;AA8Y5B;AApYI;EACI,qBAAA;AAsYR;AAnYI;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBDxMU;AC6kBlB;AAnYQ;EACI,YAAA;AAqYZ;AAjYI;EACI,yBAAA;EACA,2EAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAmYR;AAhYI;EACI,sBAAA;EACA,kCD/MQ;ECgNR,kBAAA;AAkYR;AAhYQ;EACI,gBAAA;EACA,eAAA;EACA,wBDlMG;ACokBf;AAhYQ;EACI,wBDnMG;ECoMH,gBAAA;EACA,eAAA;EAEA,mBAAA;AAiYZ;AA7XgB;EACI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA+XpB;AA3XQ;EACI,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA6XZ;AA5XY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA8XhB;AA5XY;EACI,gBAAA;AA8XhB;;AAxXA;EACI,kBAAA;AA2XJ;AA1XI;EACI,qBAAA;AA4XR;AA1XQ;EACI,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AA4XZ;AA1XY;EACI,iBAAA;AA4XhB;AA3XgB;EACI,cAAA;EACA,UAAA;AA6XpB;AAzXY;EACI,kDAAA;AA2XhB;AAvXQ;EACI,aAAA;EACA,eAAA;AAyXZ;AAtXQ;EACI,aAAA;EACA,uBAAA;AAwXZ;AAvXQ;EACI,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BD9SM;EC+SN,iCAAA;EACA,kBAAA;AAyXZ;AArXQ;EACI,iDAAA;AAuXZ;AAnXI;EACI,iBAAA;AAqXR;;AAhXA;EACI,aAAA;AAmXJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}","@import '../../index.scss';\n\n.loader {\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    font-weight: 900;\n    font-size: 24px;\n    line-height: 90px;\n\n    &__title {\n        position: absolute;\n        top: 45%;\n        left: 50%;\n        transform: translate(-45%, 0%);\n    }\n\n    .linear_progress {\n        position: absolute;\n        top: 58%;\n        left: 50%;\n        transform: translate(-50%, 0%);\n        background-image: linear-gradient(89.91deg, rgba(220, 34, 255, 0.5) 12.07%, rgba(57, 161, 244, 0.5) 89.16%);\n        margin-left: 1em;\n        width: 414px;\n        // width: calc(100% - 2em);\n        // height: 0.15em;\n\n        .MuiLinearProgress-bar {\n            background-color: #fff;\n            width: 1.5em;\n        }\n    }\n}\n\n.HLinks:hover {\n    background: #F8F8F8;\n}\n\n.BOXXX {\n    // width: calc(100%/3);\n    background: white;\n    font-size: 16px;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 162px;\n\n    margin-right: 58px;\n}\n\n\n.selected {\n    border-radius: 18px;\n}\n\n.credential {\n    flex-grow: 1;\n\n    &__body {\n        background-color: $clr-light-800;\n        // padding: 1.5rem 4rem;\n        position: relative;\n\n        .links_container{\n            .sc-ftvSup{\n                padding: 0 72px 0 75px;\n            }\n        }\n\n        .setting__container{\n            padding-right: 72px;\n            padding-left: 75px;\n        }\n\n        .setting_btn{\n            position: relative;\n            &.SBOX{\n                &:before {\n                    background-color: #4D4DF6;\n                    bottom: -12px;\n                    content: \"\";\n                    height: 2px;\n                    left: 0px;\n                    // opacity: 0;\n                    position: absolute;\n                    right: 0px;\n                    transform-origin: left center;\n                    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;\n                    // visibility: hidden;\n                    width: 100%;\n                };\n            }\n            p{\n                margin-bottom: 0;\n                font-size: 16px; \n                a{\n                    color: $clr-primary-600;\n                    text-decoration: none;\n                }\n            }\n        }\n\n        .refresh__msg{\n            .header__msg{\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                margin-bottom: 15px;\n                .success_icon_msg{\n                    font-weight: 700;\n                    font-size: 12px;\n                    color: #FDFDFD;\n                    letter-spacing: 0.15px;\n                }\n                .success-close{\n                    font-weight: 400;\n                    font-size: 12px;\n                    color: #FDFDFD;\n                    letter-spacing: 0.15px;\n                }\n            }\n            .success-msg{\n                margin: 0;\n                font-weight: 300;\n                font-size: 12px;\n                color: #FDFDFD;\n                letter-spacing: 0.15px;\n                margin-bottom: 13px;\n                overflow: hidden;\n            }\n        }\n\n        &__success {\n\n            .success-msg {\n                color: $clr-dark-900;\n                margin-left: 1em;\n                margin-right: 1em;\n            }\n\n            .success-close {\n                color: $clr-dark-600;\n                text-decoration: underline;\n                cursor: pointer;\n            }\n        }\n\n        &__list{\n            .tab__header{\n                .tab__header__item.active{\n                    background: $clr-dark-300;\n                    color: #fff;\n                }\n                .tab__header__item{\n                   width: 186px;\n                   transition: all 0.1s ease-in-out;\n                }\n            }\n            .tab__body{\n                .MuiBox-root{\n                    padding: 0;\n                    pre {\n                        margin-top: 0 !important;\n                        background-color: hsla(214, 4%, 31%, 1) !important;\n                        overflow-y: auto;\n                        border-radius: 0 !important;\n                        scrollbar-width: thin;\n                        scrollbar-color: #C4C4C4 $clr-dark-200;\n              \n                        &::-webkit-scrollbar {\n                          width: 0.25em;\n                          height: 0.25em;\n                          margin-right: -1em;\n                          background-color: $clr-dark-200;\n                        }\n              \n                        &::-webkit-scrollbar-thumb {\n                          background-color: #C4C4C4;\n                          border-radius: 3px;\n              \n                          &:hover {\n                            background-color: hsla(240, 100%, 44%, 0.39);\n                          }\n                        }\n                      }\n                }\n            }\n        }\n\n    }\n\n    &__body__header {\n        margin-bottom: 0.75em;\n    }\n\n    &__body__header-text {\n        font-size: 30px;\n        letter-spacing: 0.15px;\n        font-weight: 900;\n        color: $clr-primary-900;\n\n        span {\n            opacity: 0.5;\n        }\n    }\n\n    &__body__header-btn {\n        background-color: #1F27AC;\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 3px 5px rgba(0, 0, 0, 0.2);\n        border: none;\n        text-transform: uppercase;\n        font-size: 12px;\n        letter-spacing: 0.25px;\n        padding-left: 2rem;\n        padding-right: 2rem;\n    }\n\n    .setting__bottom__container{\n        padding: 0px 33px 13px;\n        background-color: $clr-light-900;\n        border-radius: 5px;\n\n        .subHeader, .dark{ \n            font-weight: 400;\n            font-size: 15px;\n            color: $clr-dark-300;\n        }\n        .subPara{\n            color: $clr-dark-200;\n            font-weight: 400;\n            font-size: 12px;\n\n            margin-bottom: 18px;\n        }\n        .MuiGrid-root{\n            .MuiInput-root{\n                input{\n                    color: #A4A6AB;\n                    padding-top: 0;\n                    padding-bottom: 0;\n                    line-height: 2;\n                    font-size: 12px;\n                }\n            }\n        }\n        .user__details{\n            border: 1px solid #E9E9E9;\n            padding: 0px 25px 0px 11px;\n            border-radius: 5px;\n            margin-bottom: 32px;\n            height: 60px;\n            span{\n                font-weight: 700;\n                font-size: 12px;\n                color: #606367;\n                letter-spacing: 0.15px;\n            }\n            .MuiBox-root{\n                margin-left: 8px;\n            }\n        }\n    }\n}\n\n.create__gate {\n    text-align: center;\n    &__body {\n        padding: 1px 14px 3px ;\n\n        .input {\n            background-color: #fff;\n            border: none;\n            width: 100% !important;\n            padding: 13px 18px;\n            border-radius: 5px;\n\n            input{\n                padding-bottom: 0;\n                &::placeholder{\n                    color: #212936;\n                    opacity: 1;\n                }\n            }\n\n            &:focus-within {\n                box-shadow: 0 0 0.05rem 0.05rem $clr-primary-300;\n            }\n        }\n\n        &__label {\n            margin: 0.5em;\n            font-size: 10px;\n        }\n\n        &__footer {\n            display: flex;\n            justify-content: center;\n        .close__btn{\n            background: #FFFFFF;\n            border: 1px solid #D5D9FE !important;\n            border-radius: 5px;\n            padding: 2px 34px !important;\n            text-transform: capitalize;\n            color: $clr-primary-600;\n            letter-spacing: 0.25px !important;\n            margin-right: 15px;\n            }\n        }\n\n        .error {\n            box-shadow: 0 0 0.05rem 0.05rem $clr-danger-400;\n        }\n    }\n\n    &.dashboard{\n        padding: 9px 14px;\n    }\n\n}\n\n.update__error, .updateBlank__error{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
